<abc-accordion
  class="accordion-style implement-plain-container"
  [collapsible]="true"
  [selectedIndex]="0"
  [width]="'100%'"
  [animationDuration]="300"
  [visible]="true"
  [multiple]="false"
  [dataSource]="['Test']"
>
  <div *dxTemplate="let implementationPlan of 'title'" class="dx-accordion-item-title">
    {{ this.dataService.res('Ubt-MeasureDetail-Implementation-Plan') }}
  </div>
  <div *dxTemplate="let company of 'item'">
    <div fxLayout="column" fxLayoutGap="10px">
      <div fxLayout="row" fxLayoutGap="20px" class="container-card">
        <div fxLayoutAlign="center start" class="accordionStyle ellipsis" fxLayout="column" fxFlex="25">
          {{ this.dataService.res('Ubt-TreeList-Milestones-Tasks') }}
        </div>
        <div fxLayoutAlign="center" class="accordionStyle ellipsis" fxLayout="column" fxFlex="30">
          <div fxLayout="row">
            <img class="date-start-style" src="assets/images/dateStart.svg" />
            <div>{{ currentMeasure.StartDate | date: 'dd.MM.yyyy' }}</div>
          </div>
        </div>
        <div fxLayoutAlign="center" class="accordionStyle ellipsis" fxLayout="column" fxFlex="30">
          <div fxLayout="row">
            <img class="date-start-style" src="assets/images/dateEnd.svg" />
            <div>{{ currentMeasure.EndDate | date: 'dd.MM.yyyy' }}</div>
          </div>
        </div>
        <div fxLayout="column" fxLayoutGap="10px">
          <abc-button
            [stylingMode]="'text'"
            [text]="dataService.res('Ubt-MeasureTask-Create-Task')"
            icon="plus"
            [useSubmitBehavior]="false"
            [class.active]="isNotificationActive"
            class="buttons-container active"
            [disabled]="!canManageTasks"
            (onClick)="addTask()"
          >
          </abc-button>
        </div>
        <div fxLayout="column" fxLayoutGap="10px">
          <abc-button
            [stylingMode]="'text'"
            [text]="dataService.res('Ubt-MeasureTask-Create-Milestone')"
            icon="plus"
            [useSubmitBehavior]="false"
            [class.active]="isNotificationActive"
            class="buttons-container active"
            (onClick)="addMilestone()"
            [disabled]="!canManageMilestones"
          >
          </abc-button>
        </div>
      </div>
      <div fxLayout="row">
        <abc-grid
          #meausreTaskTree
          id="MeasureAufgabenGrid"
          class="grid-group-by-Style tree-list-style"
          (onCellPrepared)="cellPrepared($event)"
          (onRowPrepared)="rowPrepared($event)"
          [dataSource]="currentMeasure.MeasureTasks"
          [setupDefaultLayoutOnInitialization]="true"
          [columns]="taskColumns"
          [showBorders]="true"
          (onCellClick)="onCellClick($event)"
        >
          <dxo-paging [enabled]="false"></dxo-paging>
        </abc-grid>
      </div>
    </div>
  </div>
</abc-accordion>

<ubt-geods-milestone #milestoneComponent [canManageMilestones]="canManageMilestones"> </ubt-geods-milestone>

<ubt-geods-task #taskComponent [canManageTasks]="canManageTasks"> </ubt-geods-task>

<abc-popup
  #confirmTaskPopup
  [width]="'25%'"
  fxLayout="column"
  fxLayoutAlign="center center"
  [height]="'auto'"
  [title]="dataService.res('Ubt-MeasureList-Confirm-Delete')"
  [showCloseButton]="true"
>
  <div
    class="dx-card popup-card-paddings card-radius"
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayoutGap="20px"
  >
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px">
      {{ dataService.res('Ubt-MeasureList-Delete-Message') }}
    </div>
    <dxi-item itemType="group" fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="20px">
      <abc-button
        class="submit-button"
        [text]="dataService.res('Ubt-Company-Icon-Delete')"
        (onClick)="deleteTask($event)"
      >
      </abc-button>
      <abc-button
        class="cancel-button"
        [text]="dataService.res('Ubt-Company-Button-Cancel')"
        (onClick)="abortTaskDelete()"
      >
      </abc-button>
    </dxi-item>
  </div>
</abc-popup>
<abc-context-menu
  #contextMenu
  id="contextMenu"
  class="abc-context-menu"
  showEvent="abcclick"
  [items]="contextMenuItems"
  [position]="{ my: 'top right', at: 'bottom right' }"
>
</abc-context-menu>
